// extracted by mini-css-extract-plugin
module.exports = {"content-box":"_1ALxve3UkEkFE0Ee3YtGKi","preLoaderShimmer":"_2Y3F4NjJ-knNoej332gjzI"};